<template>
  <form>
    <base-card>
      <product-image @setImage="setImage" :image="targetItem.image" class="two" />
      <base-input
        :label="StringLanguage.productName"
        v-model="targetItem.name"
      />
      <base-textarea
        :label="`${StringLanguage.ingredients} / ${StringLanguage.description}`"
        v-model="targetItem.description"
        rows="4"
        :class="{ m_0: targetItem.sizes && targetItem.sizes.length > 1 }"
      />
      <div class="half-cols mt_15">
        <base-input
          v-if="targetItem.sizes && targetItem.sizes.length == 1"
          :label="StringLanguage.value"
          v-model="targetItem.sizes[0].price"
          class="mr_5 flex"
          :money-mask="StringLanguage.currencyConfigs"
        />
        <base-input
          v-if="targetItem.sizes && targetItem.sizes.length == 1"
          :label="StringLanguage.promo"
          v-model="targetItem.sizes[0].originalPrice"
          class="ml_5 flex"
          :money-mask="StringLanguage.currencyConfigs"
        />
      </div>
    </base-card>

    <base-card v-if="targetItem.sizes && targetItem.sizes.length > 1">
      <div class="row half-cols">
        <div class="col-lg-4 col-xs-4">
          <p class="text-title">{{ StringLanguage.size }}</p>
        </div>
        <div class="col-lg-4 col-xs-4">
          <p class="text-title">{{ StringLanguage.value }}</p>
        </div>
        <div class="col-lg-4 col-xs-4">
          <p class="text-title">{{ StringLanguage.promo }}</p>
        </div>
      </div>

      <div v-for="size in targetItem.sizes" :key="size._id">
        <div class="row half-cols">
          <div class="col-lg-4 col-xs-4">
            <base-input
              :value="size.name"
              class="mb_0"
              title="Para alterar este tamanho, vá até a categoria do produto"
              disabled
            />
          </div>
          <div class="col-lg-4 col-xs-4">
            <base-input
              v-model="size.price"
              class="mb_0"
              :money-mask="StringLanguage.currencyConfigs"
            />
          </div>
          <div class="col-lg-4 col-xs-4">
            <base-input
              v-model="size.originalPrice"
              class="mb_0"
              :money-mask="StringLanguage.currencyConfigs"
            />
          </div>
        </div>
      </div>
    </base-card>

    <!-- Etapas -->
    <div v-for="(step, i) in targetItem.items" :key="step._id">
      <base-card v-if="!step.delete" class="relative">
        <p class="step-title" :class="sortMode.step ? 'ml_5' : 'text-center'">
          {{ StringLanguage.step }}
        </p>

        <div class="step-icons">
          <div v-if="sortMode.step">
            <i
              @click="moveItem(step, i, true)"
              class="fal fa-chevron-up mr_15"
            ></i>
            <i
              @click="moveItem(step, i, false)"
              class="fal fa-chevron-down ml_15"
            ></i>
          </div>

          <span v-else @click="deleteItem(step._id)"
            ><i class="fal fa-times"></i
          ></span>
        </div>

        <!-- Box UMA etapa -->
        <div>
          <base-input
            :placeholder="StringLanguage.question"
            v-model="step.name"
            :disabled="sortMode.step"
          />

          <div v-if="!sortMode.step">
            <div class="hr" />
            <div
              v-if="step.items.filter((i) => !i.delete).length > 0"
              class="d-flex w-100"
            >
              <p class="text-title double">{{ StringLanguage.answer }}</p>
              <p class="text-title double left pl_5">{{ deleteMode.step == step._id ? '' : StringLanguage.value }}</p>
            </div>
            <div v-if="step.items.filter((i) => !i.delete).length > 0">
              <div
                v-for="(awnser, i) in step.items.filter((i) => !i.delete)"
                :key="i"
              >
                <div class="d-flex">
                  <base-input
                    v-model="awnser.name"
                    :disabled="deleteMode.step == step._id"
                    class="pr_5 mb_0 flex_1"
                    @focus="itemTextChange(awnser)"
                  />
                  <div class="wpx-120 wpx-min-120">
                    <base-button
                      v-if="deleteMode.step == step._id"
                      :text="StringLanguage.delete"
                      design="four"
                      @click.prevent="awnser.delete = true"
                      class="mt_10 w-100 big"
                    />
                    <base-input
                      v-else
                      v-model="awnser.price"
                      class="pl_5 mb_0"
                      :money-mask="StringLanguage.currencyConfigs"
                      @focus="itemTextChange(awnser)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="step.items.filter((i) => !i.delete).length > 0"
              class="d-flex mt_25"
            >
              <base-button
                v-if="
                  !deleteMode.step ||
                  deleteMode.step != step._id ||
                  step.items.length === 0
                "
                :text="StringLanguage.add"
                class="w-100"
                :class="{ mr_5: !deleteMode.step && step.items.length > 0 }"
                design="two"
                @click.prevent="addOption(step._id)"
              />
              <base-button
                v-if="step.items.filter((i) => !i.delete).length > 0"
                :text="
                  deleteMode.step == step._id
                    ? StringLanguage.back
                    : StringLanguage.remove
                "
                design="four"
                class="w-100 ml_5"
                @click.prevent="
                  deleteMode.step =
                    deleteMode.step != step._id ? step._id : false
                "
              />
            </div>

            <div
              v-else-if="!copyCategory.enabled.hasOwnProperty(step._id)"
              class="mt_25"
            >
              <base-button
                :text="StringLanguage.addAnswer"
                design="two"
                class="w-100"
                @click.prevent="addOption(step._id)"
              />
              <base-button
                v-if="categories"
                :text="StringLanguage.copyProductNames"
                design="two"
                class="w-100 mt_15"
                @click.prevent="enableCopyToStep(step._id)"
              />
            </div>

            <!-- TO DO - Aparecer isso após clicar em "Copiar nomes de produtos" -->
            <div
              v-if="copyCategory.enabled.hasOwnProperty(step._id) && categories"
              class="mt_25"
            >
              <base-select
                :title="StringLanguage.selectCategory"
                @change="
                  selectCopyCategory(step._id, arguments[0].target.value)
                "
              >
                <option
                  v-for="category in categories"
                  :value="category._id"
                  :key="category._id"
                >
                  {{ category.name }}
                </option>
              </base-select>

              <!-- Aparece após de fato copiar nomes de produtos -->
              <base-message class="gold mt_20">
                {{ StringLanguage.aboutCopyProductNames }}
              </base-message>

              <div class="d-flex mt_25">
                <base-button
                  :text="StringLanguage.confirm"
                  design="two"
                  class="flex_1 py_10 mr_10"
                  @click.prevent="copyCategoryNames(step._id)"
                />
                <base-button
                  :text="StringLanguage.cancel"
                  design="four"
                  class="flex_1 py_10 ml_10"
                  @click.prevent="cancelCopyCategoryNames(step._id)"
                />
              </div>
            </div>

            <div class="hr" />

            <div class="d-flex mt_5">
              <base-input
                :label="StringLanguage.minToSelect"
                class="mr_5 mb_0 flex_1"
                v-model="step.min"
                @change="step.max = Math.max(step.min, step.max)"
              />
              <base-input
                :label="StringLanguage.maxToSelect"
                class="ml_5 mb_0 flex_1"
                v-model="step.max"
                @change="step.min = Math.min(step.min, step.max)"
              />
            </div>
          </div>
        </div>
      </base-card>
    </div>
    <div>
      <base-card>
        <div class="d-flex">
          <base-button
            v-if="targetItem.items.filter((i) => !i.delete).length > 1"
            :text="sortMode.step ? StringLanguage.save : StringLanguage.sort"
            class="w-100"
            :class="{ mr_5: !sortMode.step }"
            design="four"
            @click.prevent="sortMode.step = !sortMode.step"
          />
          <base-button
            v-if="!sortMode.step"
            :text="StringLanguage.addStep"
            design="two"
            class="w-100 ml_5"
            @click.prevent="addStep()"
          />
        </div>
      </base-card>
    </div>

    <!-- Disponibilidade -->
    <base-availability
      name="do produto"
      :availability="targetItem.availability"
      @updateAvailability="updateAvailability"
    ></base-availability>
    <!-- fim Disponibilidade -->
  </form>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import store from "@/store";
import Builder from "@/plugins/core/schema/components/Builder.js";
import { Money } from "v-money";
import { getXAPIEnv } from "@/plugins/account";

import ProductImage from "@/containers/Catalog/ProductImage";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseTextarea from "@/components/Textarea";
import BaseSelect from "@/components/Select";
import BaseMessage from "@/components/Message";
import BaseBox from "@/components/Box";
import StringTemplate from "easyjs/lib/Tools/StringTemplate";
import BaseAvailability from "@/containers/Availability";

export default {
  data() {
    return {
      StringTemplate,
      targetItem: this.modelItem || Builder.factory("Step"),
      copyCategory: {
        enabled: {},
      },
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      deleteMode: {
        step: false,
      },
      sortMode: {
        step: false,
      },
      ccnMessage: false,
    };
  },
  props: {
    originCatalog: {},
    modelItem: {},
  },
  components: {
    ProductImage,
    BaseCard,
    BaseInput,
    BaseButton,
    BaseTextarea,
    BaseSelect,
    BaseMessage,
    BaseAvailability,
  },
  updated() {
    this.reorderSteps();
  },
  methods: {
    setChangeToItem(item) {
      switch (item.type) {
        case "option":
          item.changed = true;
          item.parent_ref.changed = true;
          item.parent_ref.parent_ref.changed = true;
          break;
        case "question":
          item.changed = true;
          item.parent_ref.changed = true;
          break;
        case "step":
          item.changed = true;
          break;
      }
    },
    itemTextChange(item) {
      item.optionTextChanged = true;
    },
    reorderSteps() {
      if (!this.catalogReorderedSteps) {
        this.targetItem.items.forEach((question) => {
          question.items.sort((a, b) => {
            if (a._id > b._id) return 1;
            if (a._id < b._id) return -1;
            // a must be equal to b
            return 0;
          });
        });

        store.commit("catalog/setReorderedSteps", true);
      }
    },
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
    enableCopyToStep(step_id) {
      this.copyCategory.enabled = {
        ...this.copyCategory.enabled,
        [step_id]: null,
      };
    },
    selectCopyCategory(step_id, category_id) {
      let categories = this.originCatalog.getItemsByParam("_id", category_id);
      this.copyCategory.enabled[step_id] =
        categories.length > 0 ? categories[0] : null;
      return true;
    },
    copyCategoryNames(step_id) {
      this.ccnMessage = true;

      if (!this.copyCategory.enabled[step_id]) {
        return false;
      }
      let category = this.copyCategory.enabled[step_id];
      let items = category.items;
      new Set(items.map((i) => i.name)).forEach((name) => {
        let option = this.addOption(step_id);
        option.name = name;
      });

      delete this.copyCategory.enabled[step_id];
    },
    cancelCopyCategoryNames(step_id) {
      if (!this.copyCategory.enabled.hasOwnProperty(step_id)) {
        return false;
      }

      delete this.copyCategory.enabled[step_id];
      Vue.set(this.copyCategory, "enabled", this.copyCategory.enabled);
      this.$forceUpdate();
      return true;
    },
    setImage(fileName) {
      this.targetItem.image = fileName;
    },
    setModel(item, parent) {
      this.cleanModel();
      this.originCategory = parent;
      this.targetItem = item || Builder.factory("Step");
      this.targetItem.parent_ref = parent;
      this.targetItem.parent = parent._id || null;
      if (this.targetItem.sizes.length == 0) {
        this.targetItem.addItems(this.originCategory.sizes);
      }
      this.targetItem.sizes.map((size) => {
        if (size.originalPrice > size.price) {
          let aux = size.price;
          size.price = size.originalPrice;
          size.originalPrice = aux;
        }
      });
    },
    cleanModel() {
      for (let key of Object.keys(this.deleteMode)) {
        this.deleteMode[key] = false;
      }
      for (let key of Object.keys(this.sortMode)) {
        this.sortMode[key] = false;
      }
      this.copyCategory.enabled = {};
    },
    moveItem(item, currentIndex, up) {
      let itemParent = item.parent_ref;
      let newIndex = currentIndex + (up ? -1 : 1);
      if (newIndex < 0 || newIndex >= itemParent.length) {
        return false;
      }
      itemParent.items.splice(
        newIndex,
        0,
        itemParent.items.splice(currentIndex, 1)[0]
      );
      itemParent.items.forEach((item, index) => {
        item.position = index;
        this.setChangeToItem(item);
      });
      this.$forceUpdate();
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam("_id", target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId("_");

      if (newItem.type == "question") {
        newItem.min = 0;
      }

      (newItem.parent = item._id), item.addItems(newItem);

      this.setChangeToItem(newItem);

      return newItem;
    },
    addStep() {
      this.addNewItem("Question", this.targetItem._id);
    },
    addOption(id) {
      this.deleteMode.step = false;
      return this.addNewItem("Option", id);
    },
    deleteItem(id) {
      if (id) {
        let item = this.targetItem.getItemsByParam("_id", id)[0];
        item.delete = true;
        return;
      }
      this.targetItem.delete = true;
      // this.save(this.targetItem);
      this.$emit("saveItem", this.targetItem);
    },
    getItem() {
      this.cleanModel();
      return this.targetItem;
    },
    changeStepTab(tab) {
      this.deleteMode.size = false;
      this.stepTab = tab;
    },
  },
  computed: {
    environment() {
      return getXAPIEnv();
    },
    categories() {
      let categories = this.originCatalog
        ? this.originCatalog
            .getItemsByParam("type", "category")
            .filter((i) => i.mode != "step")
        : [];
      return categories.length > 0 ? categories : null;
    },
    ...mapState({
      catalogReorderedSteps: (state) => state.catalog.reorderedSteps,
    }),
  },
};
</script>
<style scoped>
.text-title {
  text-transform: uppercase;
  color: #868686;
  font-weight: 900;
  font-size: 10px;
  width: 100%;
}
.hr {
  border-bottom: 1px solid #4a4a4a;
  margin-top: 20px;
  margin-bottom: 25px;
}
.text-title.double:not(.left) {
  text-align: left !important;
  margin-bottom: 5px;
}
.text-title.left {
  text-align: left !important;
  width: 120px;
  margin: 0 45px 0 30px;
}
.step-title {
  color: var(--label-primary);
  font-size: 1.4em;
  font-weight: bold;
  margin-bottom: 15px;
}
.step-icons {
  font-size: 1.4em;
  position: absolute;
  top: 25px;
  right: 0;
  color: var(--label-primary);
  cursor: pointer;
}

.step-icons i {
  font-size: 1em;
  padding: 0.25rem;
}

.flex_1 {
  flex: 1;
}

.half-cols {
  display: flex;
  justify-content: space-between;
}
</style>